<main class="main-body-wrap">
    <header class="n-head-wrap">
        <div class="n-top-head d-flex align-items-center justify-content-between">
            <div class="s-logo-l-block d-flex">
                <div class="l-link">
                    <a href="#" class="text-end">
                        भारत सरकार
                    </a>
                    <a href="#" class="text-end">GOVERNMENT OF INDIA</a>
                </div>
                <div class="l-link">
                    <a href="#">
                        सूक्ष्म , लघु और मध्यम उद्यम मंत्रालय
                    </a>
                    <a href="#">
                        MINISTRY OF MICRO, SMALL & MEDIUM ENTERPRISES
                    </a>
                </div>
            </div>
            <nav class="nav-bar">
                <ul class="nav-list">
                    <li class="nav-item"><a href="#">
                        Nomination for Trainer/Assessor
                    </a>
                    <ul class="nav-sub-menu">
                        <li>
                            <a [routerLink]="['/nomination-form']" [queryParams]="{ type: 'basic' }">
                                Basic
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/nomination-form']" [queryParams]="{ type: 'advance' }">
                                Advance
                            </a>
                        </li>
                    </ul>
                </li>
                    <li class="nav-item"><a routerLink="/languages">Resources</a></li>
                    <li class="nav-item"><a href="#">
                            Dashboard
                        </a>
                        <ul class="nav-sub-menu">
                            <li>
                                <a [href]="summaryURL" target="_blank">
                                    Summary Dashboard
                                </a>
                            </li>
                            <li>
                                <a [href]="dbtURL" target="_blank">
                                    DBT Dashboard
                                </a>
                            </li>
                            <li>
                                <a [href]="attendanceURL" target="_blank">
                                    Attendance
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </nav>



            <!-- <div class="l-link d-flex">
                <a routerLink="/languages" style="margin-left: 670px; color: white; font-size: 12px">
                    <p style="margin-top: 1px">Resources</p>
                </a>
                <a href="https://app.powerbi.com/view?r=eyJrIjoiNzQ0NTQzNDAtOWQzNi00Njg1LTk5NmEtNDhkYjJmNDgyMWQ5IiwidCI6IjcyNGI4ZWQxLTgxODMtNGNiOS1iNWIwLTFlZDY3YWZlYWNmMSIsImMiOjEwfQ%3D%3D
                " style="margin-left: 10px; color: white; font-size: 12px;">
                    <p style="margin-top: 1px">Dashboard</p>
                </a>
            </div> -->

            <div class="s-lan-right-block">
                <ul class="d-flex">
                    <li>
                        <a href="https://twitter.com/minmsme" aria-label="Link to twitter" target="_blank">
                            <svg width="21" height="16" viewBox="0 0 300 300" version="1.1"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M178.57 127.15 290.27 0h-26.46l-97.03 110.38L89.34 0H0l117.13 166.93L0 300.25h26.46l102.4-116.59 81.8 116.59h89.34M36.01 19.54H76.66l187.13 262.13h-40.66"
                                    fill="white" stroke="white" />
                            </svg>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.youtube.com/@@ministryofmicrosmallmedium5343" aria-label="Link to youtube"
                            target="_blank">
                            <svg width="20" height="20" viewBox="0 0 20 21" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.6667 10.2174L8.75 11.8841V8.55078L11.6667 10.2174Z" fill="white"
                                    stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M1.66675 10.8066V9.62748C1.66675 7.21498 1.66675 6.00831 2.42091 5.23248C3.17591 4.45581 4.36425 4.42248 6.74008 4.35498C7.86508 4.32331 9.01508 4.30081 10.0001 4.30081C10.9842 4.30081 12.1342 4.32331 13.2601 4.35498C15.6359 4.42248 16.8242 4.45581 17.5784 5.23248C18.3334 6.00831 18.3334 7.21581 18.3334 9.62748V10.8066C18.3334 13.22 18.3334 14.4258 17.5792 15.2025C16.8242 15.9783 15.6367 16.0125 13.2601 16.0791C12.1351 16.1116 10.9851 16.1341 10.0001 16.1341C8.91321 16.1309 7.82644 16.1125 6.74008 16.0791C4.36425 16.0125 3.17591 15.9791 2.42091 15.2025C1.66675 14.4258 1.66675 13.2191 1.66675 10.8075V10.8066Z"
                                    stroke="white" stroke-width="1.25" />
                                <path
                                    d="M4.61002 4.55662C6.9196 4.44162 8.71585 4.38412 9.99919 4.38412C11.2825 4.38412 13.0796 4.44162 15.3904 4.55704C15.9951 4.58722 16.5683 4.83582 17.0036 5.25667C17.4388 5.67753 17.7066 6.24204 17.7571 6.84537C17.8629 8.10954 17.9159 9.22287 17.9159 10.1858C17.9159 11.1604 17.8617 12.2891 17.7534 13.5725C17.7031 14.1689 17.4405 14.7274 17.0133 15.1467C16.5861 15.5659 16.0227 15.818 15.4254 15.857C13.45 15.9862 11.6413 16.0508 9.99919 16.0508C8.35752 16.0508 6.54919 15.9862 4.57502 15.857C3.97796 15.818 3.41471 15.5661 2.98756 15.1471C2.56041 14.7282 2.29768 14.1699 2.2471 13.5737C2.13752 12.2808 2.08252 11.1512 2.08252 10.1858C2.08252 9.23162 2.13627 8.11787 2.24294 6.84412C2.29364 6.24094 2.56146 5.67663 2.99671 5.25594C3.43195 4.83526 4.00504 4.58678 4.6096 4.55662H4.61002Z"
                                    stroke="white" stroke-width="1.66667" stroke-linejoin="round" />
                                <path
                                    d="M8.75 8.38832V12.0533C8.74997 12.1179 8.76744 12.1812 8.80055 12.2366C8.83365 12.292 8.88115 12.3374 8.938 12.368C8.99485 12.3985 9.05892 12.4131 9.1234 12.4102C9.18787 12.4072 9.25034 12.3869 9.30417 12.3512L12.0529 10.5346C12.102 10.5022 12.1424 10.4582 12.1704 10.4064C12.1984 10.3547 12.2132 10.2968 12.2134 10.2379C12.2137 10.1791 12.1994 10.1211 12.1718 10.0691C12.1443 10.0171 12.1043 9.97278 12.0554 9.93998L9.30625 8.09165C9.25252 8.05554 9.18999 8.03472 9.12534 8.03141C9.06069 8.0281 8.99636 8.04243 8.93923 8.07286C8.88209 8.10329 8.8343 8.14867 8.80097 8.20417C8.76764 8.25966 8.75002 8.32317 8.75 8.3879V8.38832Z"
                                    stroke="white" stroke-width="1.42875" stroke-linejoin="round" />
                            </svg>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.facebook.com/minmsme?mibextid=LQQJ4d" aria-label="Link to facebook"
                            target="_blank">
                            <svg width="18" height="20" viewBox="0 0 18 17" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path opacity="1" fill-rule="evenodd" clip-rule="evenodd"
                                    d="M18 0.708333V16.2917C18 16.5732 17.5549 16.9936 17.25 17H12.75V10.625H15V7.79167H12.75V6.375C12.4226 5.46497 12.6384 4.96178 13.5 4.95833H15V2.83333C14.9584 2.63694 14.1087 2.56688 12.75 2.83333C11.0333 2.56688 9.61709 3.76433 9.75 5.66667V7.79167H7.5V10.625H9.75V17H0.75C0.445111 17 0 16.5796 0 16.2917V0.708333C0 0.420382 0.445111 0 0.75 0H17.25C17.5549 0 18 0.414013 18 0.708333Z"
                                    fill="white"></path>
                            </svg>
                        </a>
                    </li>
                    <li>
                        <button type="button" class="lang-drop dropdown-toggle" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            Language
                        </button>
                        <ul class="dropdown-menu dropdown-menu-end">
                            <li><button class="dropdown-item" type="button">हिन्दी</button></li>
                            <li><button class="dropdown-item" type="button">English</button></li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
        <div class="m-nav">
            <div class="l-m-logo">
                <div class="l-img">
                    <img src="assets/images/vs/n/emblem-dark.png" alt="" title="" />
                </div>
                <div class="l-con">
                    <h2>
                        सूक्ष्म , लघु और मध्यम उद्यम मंत्रालय
                    </h2>

                    <span>
                        Ministry of
                    </span>
                    <h1 style="font-weight:800">
                        Micro, small & Medium Enterprises
                    </h1>
                </div>
            </div>
            <div class="m-right-logo">
                <div class="g2-logo">
                    <img src="assets/images/vs/n/PM-Vishwakarma-Logo-FINAL1.png" alt="" title="" />
                </div>
                <div class="g2-logo">
                    <img src="assets/images/vs/n/g20.svg" alt="" title="" />
                </div>
                <div class="g2-logo">
                    <img src="assets/images/vs/n/azadi23.svg" alt="" title="" />
                </div>
                <!-- <div class="az-logo">
                    <img src="assets/images/vs/partners/logo4.png" alt="" title="" />
                </div> -->
            </div>
        </div>
        <div class="bottom-nav">
            <!-- <nav class="navbar navbar-expand-lg">
                <div class="container-fluid">
                    <div class="mobile-view">
                        <a class="hide-mobile" href="#">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M21 8.77217L14.0208 1.79299C12.8492 0.621414 10.9497 0.621413 9.77817 1.79299L3 8.57116V23.0858H10V17.0858C10 15.9812 10.8954 15.0858 12 15.0858C13.1046 15.0858 14 15.9812 14 17.0858V23.0858H21V8.77217ZM11.1924 3.2072L5 9.39959V21.0858H8V17.0858C8 14.8767 9.79086 13.0858 12 13.0858C14.2091 13.0858 16 14.8767 16 17.0858V21.0858H19V9.6006L12.6066 3.2072C12.2161 2.81668 11.5829 2.81668 11.1924 3.2072Z"
                                    fill="#ffffff" />
                            </svg>
                        </a>
                        MENU
                    </div>
                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="false" aria-label="Toggle navigation">

                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M2 6C2 5.44772 2.44772 5 3 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H3C2.44772 7 2 6.55228 2 6Z"
                                fill="#ffffff" />
                            <path
                                d="M2 12.0322C2 11.4799 2.44772 11.0322 3 11.0322H21C21.5523 11.0322 22 11.4799 22 12.0322C22 12.5845 21.5523 13.0322 21 13.0322H3C2.44772 13.0322 2 12.5845 2 12.0322Z"
                                fill="#ffffff" />
                            <path
                                d="M3 17.0645C2.44772 17.0645 2 17.5122 2 18.0645C2 18.6167 2.44772 19.0645 3 19.0645H21C21.5523 19.0645 22 18.6167 22 18.0645C22 17.5122 21.5523 17.0645 21 17.0645H3Z"
                                fill="#ffffff" />
                        </svg>
                    </button>
                    <div class="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                            <li class="nav-item">
                                <a class="nav-link" href="#">Home</a>
                            </li>
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button"
                                    data-bs-toggle="dropdown" aria-expanded="false">
                                    About Scheme
                                </a>
                                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <li><a class="dropdown-item" href="#" target="_blank">Scheme
                                            Guidelines</a></li>
                                    <li><a class="dropdown-item" href="#" role="button" data-bs-toggle="modal"
                                            data-bs-target="#soModal">Scheme Objectives</a></li>
                                    <li><a class="dropdown-item" href="#" role="button"
                                            data-bs-target="#EligiblityCriteriaModal"
                                            data-bs-toggle="modal">Eligibility
                                            Criteria</a></li>
                                    <li><a class="dropdown-item" href="#" role="button"
                                            data-bs-target="#EligibleTradesModal" data-bs-toggle="modal">Eligible
                                            Trades</a></li>
                                </ul>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#" role="button" data-bs-target="#SchemeBenefitsModal"
                                    data-bs-toggle="modal">Scheme Benefits</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#">Knowledge Centre</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#">FAQ</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#">What's New</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#">Contact Us</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#">How to Register</a>
                            </li>

                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownLogin" role="button"
                                    data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                                    Login
                                </a>
                                <ul class="dropdown-menu dropdown-menu-lg-end"
                                    aria-labelledby="navbarDropdownLogin">
                                    <li><a class="dropdown-item" href="#">Applicant/
                                            Beneficiary Login</a></li>

                                    <li class="dropstart">
                                        <a class="dropdown-item dropdown-toggle" data-bs-toggle="dropdown" href="#">
                                            CSC
                                            Login</a>
                                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                                            <li><a class="dropdown-item" href="#">CSC - View E-shram Data</a></li>
                                            <li><a class="dropdown-item hide-mobile" href="#">MIS Login</a></li>
                                        </ul>
                                    </li>
                                    <li class="dropstart">
                                        <a class="dropdown-item dropdown-toggle" data-bs-toggle="dropdown" href="#">
                                            Admin Login</a>
                                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                                            <li><a class="dropdown-item hide-mobile" href="#">MSME Login</a></li>
                                            <li><a class="dropdown-item hide-mobile" href="#">MSDE Login</a></li>
                                            <li><a class="dropdown-item hide-mobile" href="#">DFS Login</a></li>
                                            <li><a class="dropdown-item hide-mobile" href="#">State/ UT Login</a>
                                            </li>
                                            <li><a class="dropdown-item hide-mobile" href="#">SIDBI</a></li>
                                        </ul>
                                    </li>
                                    <li class="dropstart">
                                        <a class="dropdown-item dropdown-toggle" data-bs-toggle="dropdown" href="#">
                                            Verification Login</a>
                                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                                            <li><a class="dropdown-item hide-mobile" href="#">Gram Pradhan
                                                    Login</a></li>
                                            <li><a class="dropdown-item hide-mobile" href="#" l>ULB Login</a></li>
                                            <li><a class="dropdown-item hide-mobile" href="#">DM/DC Login</a></li>
                                            <li><a class="dropdown-item hide-mobile" href="#">MSME DFO Login</a>
                                            </li>
                                        </ul>
                                    </li>
                                    <li class="dropstart">
                                        <a class="dropdown-item dropdown-toggle" data-bs-toggle="dropdown" href="#">
                                            Lending Institution / DPA Login</a>
                                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                                            <li><a class="dropdown-item hide-mobile" href="#">Lending Institution
                                                    Login</a></li>
                                            <li><a class="dropdown-item hide-mobile" href="#">SLBC Login</a></li>
                                            <li><a class="dropdown-item hide-mobile" href="#">DPA Login</a></li>
                                        </ul>
                                    </li>

                                    <li><a class="dropdown-item hide-mobile" href="#">Enlist Gram Panchayat
                                            Pradhan</a></li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav> -->
        </div>
    </header>
    <section class="m-body-1">
        <div class="f-container">
            <div class="f-box">
                <div class="white-box">
                    <h3 style="font-weight:800">Login</h3>
                    <div class="m-stack m-stack--hor m-stack--desktop" style="margin-top: 1rem;">
                        <div class="m-stack__item m-stack__item--fluid">
                            <div class="m-login__wrapper">
                                <div class="m-login__signin">
                                    <div class="m-login__head">
                                        <h3 class="m-login__title">
                                        </h3>
                                    </div>
                                    <form class="m-login__form m-form" [formGroup]="loginForm" novalidate>
                                        <div class="form-group m-form__group">
                                            <input class="cus-input w-100 h50" type="text"
                                                placeholder="{{'Enter your Username' | translatePipe}}" name="email"
                                                autocomplete="off" formControlName="username"
                                                [(ngModel)]="userCredentials.userName">
                                        </div>
                                        <app-form-control-messages [control]="loginForm.controls.username"
                                            [name]="'Unique ID'">
                                        </app-form-control-messages>
                                        <div class="form-group m-form__group">
                                            <input class="cus-input w-100 h50" [type]="show ? 'text' : 'password'"
                                                placeholder="Password" name="password" formControlName="password"
                                                [(ngModel)]="userCredentials.password">
                                        </div>
                                        <a class="showPassword" (click)="showPassClick()" aria-hidden="true">{{show
                                            ? 'Hide' : 'Show'}}</a>
                                        <app-form-control-messages [control]="loginForm.controls.password"
                                            [name]="'Password'">
                                        </app-form-control-messages>
                                        <div class="row m-login__form-sub">
                                            <div class="col m--align-left">
                                                <a href="javascript:;" id="m_login_signup"
                                                    class="m-link m-link--focus m-login__account-link"
                                                    (click)="registerNow()">
                                                    Login With Digital Seva Connect
                                                </a>
                                            </div>
                                            <div class="col m--align-right">
                                                <a href="javascript:;" id="m_login_forget_password"
                                                    routerLink="/forgot-password" class="m-link  m--font-info">
                                                    {{"FORGOT" | translatePipe}}
                                                </a>
                                            </div>
                                        </div>
                                        <div class="m-login__form-action">
                                            <button id="m_login_signin_submit"
                                                class="blue-btn w-100 mr-t15 br8 h50 flex-grow-1 text-uppercase"
                                                [disabled]="!loginForm.valid" (click)="doLogin()">
                                                {{"LOGIN" |translatePipe}}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div class="m-stack__item m-stack__item--center">
                            <div class="m-login__account">
                                <span class="m-login__account-msg">
                                    {{"NO_ACCOUNT" |translatePipe}}
                                </span> &nbsp;&nbsp;
                                <a href="javascript:;" id="m_login_signup"
                                    class="m-link m-link--focus m-login__account-link"
                                    routerLink="/direct-registration">
                                    {{"REGISTER_NOW" | translatePipe}}
                                </a>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="user-no-block d-flex mr-t30">
                        <div class="flag-icon h50" style=" border: 1px solid #ccc;">
                            <i class="fa fa-mobile fa-2x"></i>
                        </div>
                        <input class="cus-input w-100 h50" id="MobileNo" maxlength="10" name="MobileNo"
                            placeholder="Please Enter Mobile No" type="text" value="">
                    </div>

                    <div class="r-btn-btm mr-t20">
                        <button type="submit" id="btn1"
                            class="blue-btn w-100 mr-t15 br8 h50 flex-grow-1 text-uppercase"
                            onclick="return ValidateCaptcha();">
                            Login
                        </button>
                    </div> -->
                </div>
            </div>
        </div>
    </section>

    <footer class="footer-wrap">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <table class="w-100">
                        <tbody>
                            <tr>
                                <td style="width:60%; text-align:right">
                                    <p>
                                        <!-- © 2023 NSDC All rights reserved. -->
                                        © Copyright 2023 - All Rights Reserved
                                    </p>
                                </td>
                                <td>
                                    <p>
                                        <a> Visitors Count:<strong class="count"> </strong></a>
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="s-link">
                        <a href="https://www.facebook.com/minmsme?mibextid=LQQJ4d" target="_blank">
                            <svg width="6" height="11" viewBox="0 0 6 11" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M4.5446 2.17571H5.87095V0.191345H4.31178V0.198502C2.42258 0.266269 2.03539 1.34182 2.00126 2.47147H1.99737V3.46236H0.710938V5.40565H1.99737V10.6147H3.93611V5.40565H5.52424L5.83103 3.46236H3.93674V2.86369C3.93674 2.48191 4.18757 2.17571 4.5446 2.17571Z"
                                    fill="#3B5998"></path>
                            </svg>
                        </a>
                        <a href="https://twitter.com/minmsme" target="_blank">
                            <svg width="10" height="10" viewBox="0 0 300 300" version="1.1"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M178.57 127.15 290.27 0h-26.46l-97.03 110.38L89.34 0H0l117.13 166.93L0 300.25h26.46l102.4-116.59 81.8 116.59h89.34M36.01 19.54H76.66l187.13 262.13h-40.66">
                                </path>
                            </svg>
                        </a>
                        <a href="https://www.youtube.com/@ministryofmicrosmallmedium5343" target="_blank">
                            <svg width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.81152 3.91974L0.855286 7.35857L0.855287 0.480903L6.81152 3.91974Z"
                                    fill="#FF0000"></path>
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</main>

<div class="modal fade conatiner notranslate" id="m_modal_1_2" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header textcetre">
                <h3 class="modal-title text-center" id="exampleModalLabel"> <b>{{'SMART_VERSION' | translatePipe}}
                    </b></h3>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="m-scrollable m-scroller" data-height="450" style="overflow: auto; padding-right: 10px; ">
                    <!-- <p>The black out period of SMART portal for onboarded Training Providers (TPs) and Training Centres
                        (TCs) was from 1st May 2019 to 31st May 2019. The period was used for data migration and
                        validation of the same from old SMART portal to Skill India Digital. We are now going live with
                        Beta Version of SMART on Skill India Digital. The transition will happen in two phases as under :
                    </p> -->

                    <ul>
                        <!-- <li><b>1st Phase</b> will commence from 1st June 2019</li>
                        <li><b>2nd Phase</b> will commence within first week of June 2019</li>
                        <p class="model-top"><strong>Modules/Functionalities which will be accessible in <b>Phase 1</b>:
                            </strong>
                        </p> -->
                        <p class="model-top">
                            <b>{{'SMART_BETA_VER' | translatePipe}}</b>
                        </p>
                        <ul class="f">
                            <li>{{'OLD_TP' | translatePipe}}</li>
                            <li>{{'START_REGISTRATION' | translatePipe}} </li>
                            <li> {{'SMART_CAAF' | translatePipe}} </li>
                            <li> {{'SMART_TC_CREATED' | translatePipe}} </li>
                            <li> {{'SMART_TC_LOGIN' | translatePipe}} </li>
                            <li>{{'TP/TC_STAKEHOLDER' | translatePipe}} </li><br>
                            <h5 class="align-text"><b>{{'RESET_PASSWORD' | translatePipe}}</b></h5>
                            <b class="align-text"><span style="text-decoration: underline">{{'Exceptions' |
                                    translatePipe}}</span>
                            </b>
                            <br><br>
                            <li>
                                <span>{{'DNR_TC' | translatePipe}} </span>
                                <a href="https://nsdcpublicdocuments.s3.ap-south-1.amazonaws.com/QPCode.xlsx"
                                    target="_blank" rel="noopener">
                                    <b>{{'QP_LINK' | translatePipe}}</b>
                                </a>
                                <span> {{'DNR_TC_DATA' | translatePipe}}</span>
                            </li><br>
                            <li>{{'DATA_MIGRATION' | translatePipe}} </li>
                        </ul>
                        <!-- <h5 class="underline-p text-center"><b>Please use Forget Password link to change your password on first login with your existing SMART User ID.</b></h5>
                        <p class="model-top"><strong>Modules/Functionalities which will be accessible in <b>Phase 2</b>:

                            </strong>
                        </p>
                        <li> TCs which had submitted their forms on the old SMART website will be able to login on Skill
                            India portal and carry out required actions
                        </li> -->
                    </ul>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">
                    {{'CLOSE' | translatePipe}}</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade show add-preference-role-div" id="otpVerification" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" style="padding-right: 17px;">
    <div class="modal-dialog modal-dialog-centered modal" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">One Time Password Verification</h5>
                <button (click)="resetModel()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body padding-top-null padding-bottom-null">
                <div class="m-login__signin">
                    <div class="m-login__head">
                        <h3 class="m-login__title">
                        </h3>
                    </div>
                    <form class="m-login__form m-form" [formGroup]="otpForm">
                        <div class="form-group m-form__group">
                            <label for="">OTP has been sent to your {{userContactDetails?.email}} and
                                {{userContactDetails?.phone}}</label>
                            <br>
                            <label for="">Please enter either of the OTP received on Email Address or Mobile Number in
                                the below box to Login.</label>
                            <input class="form-control m-input" type="text" maxlength="6"
                                placeholder="Enter Email/Mobile OTP" name="eOTP" formControlName="emailOTP">
                            <app-form-control-messages [control]="otpForm.controls.emailOTP"
                                [name]="'Email/Mobile OTP'">
                            </app-form-control-messages>
                        </div>
                        <!-- <div class="form-group m-form__group">
                        <h6 class="text-center otp-or"><b>OR</b></h6>
                      </div>
                      <div class="form-group m-form__group">
                        <label for="">{{userContactDetails?.phone}}</label>
                        <input class="form-control m-input" type="text" maxlength="6" placeholder="Enter Mobile OTP" name="mOTP" formControlName="mobileOTP">
                        <app-form-control-messages [control]="otpForm.controls.mobileOTP" [name]="'Mobile OTP'"></app-form-control-messages>
                      </div> -->
                        <div class="m-login__form-action ">
                            <button id="m_login_signin_submit" class="btn btn-focus  m-btn--pill btn-login"
                                (click)="generateOTPs()">
                                Resend OTP
                            </button>
                            <button id="m_login_signin_submit" class="btn btn-focus  m-btn--pill btn-login"
                                [disabled]="!validOTP" (click)="verifyOTP('everyTime')">
                                Verify OTP & Login
                            </button>

                        </div>
                    </form>
                </div>
            </div>

        </div>
    </div>
</div>

<div class="modal fade show add-preference-role-div" id="otpVerificationFirstTime" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" style="padding-right: 17px;">
    <div class="modal-dialog modal-dialog-centered modal" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Verify Contact Details</h5>
                <button (click)="resetModel();" type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body padding-top-null padding-bottom-null">
                <div class="m-login__signin">
                    <div class="m-login__head">
                        <h3 class="m-login__title">
                        </h3>
                        <label *ngIf="verifyUpdateDetails" style="font-size: 14px;" for="">
                            Hi User, Kindly verify your email id
                            <span class="contactDetails">{{userContactDetails?.email}} </span> and Mobile Number <span
                                class="contactDetails">{{userContactDetails?.phone}}</span>, if you don't have access of
                            these, You can update new email and mobile number and verify.

                        </label>
                    </div>
                    <form *ngIf="!verifyUpdateDetails" class="m-login__form m-form" [formGroup]="contactDetailForm">
                        <div class="form-group m-form__group">
                            <label for="">Enter the email address</label>
                            <input class="form-control m-input" type="text" name="Spoc-email"
                                placeholder="Enter the email address" formControlName="email">
                            <app-form-control-messages [control]="contactDetailForm.controls.email"
                                [name]="'Email of spoc'">
                            </app-form-control-messages>
                            <!-- <input class="form-control m-input" type="text" placeholder="Enter Your Email" name="" formControlName="email">
                          <app-form-control-messages [control]="contactDetailForm.controls.email" [name]="'Enter Your Email'"></app-form-control-messages> -->
                        </div>
                        <!-- <div class="form-group m-form__group">
                          <h6 class="text-center otp-or"><b>OR</b></h6>
                        </div> -->
                        <div class="form-group m-form__group">
                            <label for="">Enter the mobile number</label>
                            <input class="form-control m-input" type="text" maxlength="10" name="mobile-number"
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                placeholder="Enter mobile number" formControlName="phone">
                            <app-form-control-messages [control]="contactDetailForm.controls.phone"
                                [message]="'Mobile Number should be 10 digits'" [name]="'Mobile of spoc'">
                            </app-form-control-messages>
                            <!-- <input class="form-control m-input" type="Number" maxlength="6" placeholder="Enter Mobile Number" name="" formControlName="phone">
                          <app-form-control-messages [control]="contactDetailForm.controls.phone" [name]="'Enter Mobile Number'"></app-form-control-messages> -->
                        </div>
                        <div class="m-login__form-action ">
                            <button id="m_login_signin_submit" class="btn btn-focus  m-btn--pill btn-login"
                                [disabled]="!validContactDetail" (click)="updateContactDetails()">
                                Update & Verify
                            </button>
                        </div>
                    </form>
                    <form *ngIf="verifyUpdateDetails" class="m-login__form m-form" [formGroup]="otpForm">
                        <div class="form-group m-form__group">
                            <label for="">{{userContactDetails?.email}}</label>
                            <input class="form-control m-input" type="text" maxlength="6" placeholder="Enter Email OTP"
                                name="eOTP" formControlName="emailOTP">
                            <app-form-control-messages [control]="otpForm.controls.emailOTP" [name]="'Email OTP'">
                            </app-form-control-messages>
                        </div>
                        <!-- <div class="form-group m-form__group">
                        <h6 class="text-center otp-or"><b>OR</b></h6>
                      </div> -->
                        <div class="form-group m-form__group">
                            <label for="">{{userContactDetails?.phone}}</label>
                            <input class="form-control m-input" type="text" maxlength="6" placeholder="Enter Mobile OTP"
                                name="mOTP" formControlName="mobileOTP">
                            <app-form-control-messages [control]="otpForm.controls.mobileOTP" [name]="'Mobile OTP'">
                            </app-form-control-messages>
                        </div>
                        <div class="m-login__form-action ">
                            <button id="m_login_signin_submit" class="btn btn-focus  m-btn--pill btn-login"
                                (click)="generateOTPs()">
                                Resend OTP
                            </button>
                            <button id="m_login_signin_submit" class="btn btn-focus  m-btn--pill btn-login"
                                [disabled]="!validOTP" (click)="verifyOTP()">
                                Verify OTP & Login
                            </button>
                        </div>
                    </form>
                </div>
            </div>

        </div>
    </div>
</div>



<div class="modal fade show" id="spoc-confirmation" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">SPOC Change Confirmation</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <p>Do you still have access to this email {{spoc?.email}} and the mobile number {{spoc?.phone}}, if you
                    want to change SPOC, <a href="javascript:;" rel="noopener noreferrer" (click)="spocChange()">click
                        here</a> </p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal"
                    (click)="ContinueForOtpVerification()">No,
                    Continue</button>
                <button type="button" class="btn btn-primary" (click)="spocChange()">Change SPOC</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="login-otp-model" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content alignModel">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">
                    OTP Verification
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeOTPModel()">
					<span aria-hidden="true">
						&times;
					</span>
				</button>
            </div>
            <div class="modal-body">
                <form class="m-form m-form--fit m-form--label-align-right" [formGroup]="verifyOTPForm">
                    <div class="form-group m-form__group row" >
                        <label for="tp-details" class="col-3 col-form-label">
							Enter Mobile OTP:
							<span class="mandatoryColor">*</span>
						</label>
                        <div class="col-6">
                            <input class="form-control m-input notranslate" type="text" formControlName="mobileOTP" maxlength="6" placeholder="Enter mobile OTP">
                            <app-form-control-messages [control]="verifyOTPForm.controls.mobileOTP" [name]="'Mobile OTP'"></app-form-control-messages>
                        </div>
                        <div class="col-3">
                            <button type="button" class="btn btn-next verifybutton" [disabled]="timeRemaining" (click)="reGenerateOTPForLoginVerification()">
                                Regenerate OTP
                            </button>
                            <p class="otp-timer">Regenerate OTP after: {{ timeRemaining }} seconds</p>
                        </div>
                    </div>

                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-next verifybutton" [disabled]="!verifyOTPForm.valid" (click)="verifyLoginOTP()">
					Verify
				</button> &nbsp; &nbsp;
                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeOTPModel()">
					Cancel
				</button>

            </div>
        </div>
    </div>
</div>
